import { connect } from "react-redux";
import { getMaintenanceSections } from "../../actions/user";
import Maintenance from "./Maintenance";

const mapStateToProps = state => {
    return {
        maintenanceSections: state.user.maintenanceSections,
        isFetchingMaintenanceSections: state.user.isFetchingMaintenanceSections,
    };
};

const mapDispatchToProps = (dispatch) => ({
    getMaintenanceSections() {
      dispatch(getMaintenanceSections());
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(Maintenance);
